module.exports = __webpack_public_path__ + "img/img-medal-silver.e15264bb.svg";